export default __webpack_public_path__ + "static/media/kiosk-gift-card-scan.73ae16ca.gif";